// extracted by mini-css-extract-plugin
export default {"orange":"#d65d00","chart_orange":"#e36f1e","blue":"#3172af","chart_blue":"#336195","dark_text":"#3172af","light_text":"#646568"};